<template>
	<div
		class="row"
	>
		<div class="col-12 mb-4 ">
			<b-button variant="link" class="p-0 mb-4 d-none d-lg-block" @click="setStep(STEPS.INFO)">
				Вернуться назад
			</b-button>
			<div class="mb-2">
				<div class="title">
					Необходимые документы
				</div>
				<div>
					Вы сможете дозагрузить документы позднее, в личном кабинете
				</div>
			</div>
			<div v-if="!isDocumentsShow" class="pt-5 w-100 d-flex justify-content-center">
				<b-spinner class="spinner" variant="primary" />
			</div>
			<documents
				v-else
				ref="documents"
				:order="order.data"
			/>
		</div>
		<div class="col-12 order-7 d-flex justify-content-start">
			<div class="w-100 d-flex">
				<b-button
					variant="outline-primary"
					class="w-25 d-lg-none formulate-input mr-2"
					@click="setStep(STEPS.INFO)"
				>
					Назад
				</b-button>
				<FormulateInput
					type="submit"
					class="submit mb-2 w-100"
					:disabled="isLoading"
					@click="submitHandler"
				>
					<span v-if="isLoading">
						<b-spinner small />
					</span>
					<span v-else>Продолжить</span>
				</FormulateInput>
			</div>
		</div>
	</div>
</template>

<script>
import Documents from '~/components/panels/formulate/components/documents-new/Documents.vue';
import paymentFormMixin from '~/mixins/paymentFormMixin';
import { DOCUMENTS_VERIFICATION_TYPES } from '~/utils/dictionaries';
import {
	mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';

export default {
	name: 'SecondStep',
	components: { Documents },
	mixins: [paymentFormMixin],
	provide() {
		return {
			setDocuments: (slug, val) => {
				this.documents[slug] = { ...val };
			},
		};
	},
	props: {
		order: {
			type: Object,
			default: () => {},
		},
		block: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			documents_verifications_types: DOCUMENTS_VERIFICATION_TYPES,
			documents: {
				snils_document: {},
				passport_document: {},
				education_document: {},
				document_change_surname: {},
			},
			isDocumentsShow: false,
		};
	},
	computed: {
		...mapGetters('scenarios/paymentForm', [
			'baseForm',
			'currentRedirectStep',
		]),
		...mapState('scenarios/paymentForm', [
			'orderHash',
			'isLoading',
		]),
		productsWithAdmission() {
			return this.order.data.products.filter(
				(p) => p.documents_verification_type === this.documents_verifications_types.ADMISSION,
			);
		},
	},
	watch: {
		'documents.education_document.noEducation': {
			handler(val) {
				this.$emit('changeNoEducation', val);
			},
		},
	},
	async mounted() {
		await this.getDocuments();
	},
	methods: {
		...mapActions('scenarios/paymentForm', [
			'setCurrentStep',
		]),
		...mapMutations('scenarios/paymentForm', [
			'setForm',
			'setStep',
			'setLoading',
		]),
		async getDocuments() {
			this.setLoading(true);
			try {
				const { data } = await this.$api.getUserDocuments(this.orderHash);

				if (data?.education_document) {
					this.documents.education_document = data.education_document;
					this.documents.snils_document = data.snils_document;
					this.documents.passport_document = data.passport_document;
					this.documents.document_change_surname = data.document_change_surname;

					await this.syncLocalForm();
				}
			} catch (e) {
				console.error(e);
			} finally {
				this.setLoading(false);
				this.isDocumentsShow = true;
			}
		},
		syncLocalForm() {
			const documents = { ...this.documents };
			this.syncForm(['documents'], { documents });
		},
		async submitHandler() {
			try {
				this.setLoading(true);
				let formData = new FormData();

				formData = this.createFormData(this.documents.education_document, 'education_document');
				formData = this.createFormData(this.documents.passport_document, 'passport_document', formData);
				formData = this.createFormData(this.documents.snils_document, 'snils_document', formData);
				formData = this.createFormData(this.documents.document_change_surname, 'document_change_surname', formData);

				await this.$api.saveUserDocuments(this.orderHash, formData);

				const nextStep = this.currentRedirectStep || this.STEPS.PAYMENT;
				await this.setCurrentStep(nextStep);

				this.isDocumentsShow = false;
				await this.getDocuments();
				this.$emit('updateOrder');
			} catch (e) {
				console.log(e);
			} finally {
				this.setLoading(false);
			}
		},
		createFormData(data, baseKey, oldFormData = null) {
			const newData = {};
			Object.assign(newData, data);
			let formData = new FormData();
			if (oldFormData) formData = oldFormData;
			Object.keys(newData).forEach((key) => {
				if (newData[key]
					&& (!(newData[key] instanceof Object || Array.isArray(newData[key]))
						|| newData[key])) {
					formData.append(`${baseKey}[${key}]`, newData[key]);
				} else if (newData[key] && 'fileList' in newData[key]) {
					if (newData[key].files.length === 0) {
						formData.append(`${baseKey}[${key}]`, null);
					} else if (newData[key].files[0].file) {
						formData.append(`${baseKey}[${key}]`, newData[key].files[0].file);
					}
				}
			});

			return formData;
		},
		handleChangeOrder(order) {
			this.$emit('handleChangeOrder', order);
		},
		changeStatus(status) {
			this.$emit('changeStatus', status);
		},
		validate() {
			this.submitHandler();
		},
	},
};

</script>

<style scoped lang="scss">

</style>
